export default {
  "content": "<g fill-rule=\"evenodd\" clip-path=\"url(#icon_emptystate_activate_svg__a)\" clip-rule=\"evenodd\"><path d=\"M15.592 4.853l-3.2-1.827a.895.895 0 00-.493-.107L2.405 4.066a.802.802 0 00-.706.88l.093.787a1.413 1.413 0 011.56 1.213A1.408 1.408 0 012.139 8.52l.093.8c.053.44.453.747.893.694l3.894-.467v5.734c0 .4.32.72.72.72h1.226c.4 0 .72-.32.72-.72V9.226l2.933-.347a.8.8 0 00.454-.213l2.68-2.533a.812.812 0 00-.147-1.28h-.013zm-5.907-3.5c0-.734-.6-1.334-1.333-1.334-.734 0-1.334.6-1.334 1.334v.866l2.667-.32v-.546z\"/></g><defs><clipPath id=\"icon_emptystate_activate_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};